import { render, staticRenderFns } from "./chartStacked.vue?vue&type=template&id=c2fcaf54&"
import script from "./chartStacked.vue?vue&type=script&lang=js&"
export * from "./chartStacked.vue?vue&type=script&lang=js&"
import style0 from "./chartStacked.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports